import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getProjectUsers = api(async function getProjectUsers({ projectId, searchTerm, filterRoles } = {}) {
    return query(
        gql`
            query GetProjectUsers($projectId: String!, $searchTerm: String, $filterRoles: [String]) {
                getProjectUsers(projectId: $projectId, searchTerm: $searchTerm, filterRoles: $filterRoles) {
                    total
                    users {
                        authoringProjects {
                            projects {
                                name
                            }
                            total
                        }
                        id
                        UserName
                        UserId
                        client
                        projectRoles
                        metadata {
                            jobTitle
                            company
                            displayName
                            photoURL
                            email
                        }
                    }
                }
            }
        `,
        { projectId, searchTerm, filterRoles },
        { returns: "getProjectUsers" }
    )
})
